import { FC } from 'react';

import styled from '@emotion/styled';
import { InputBase, MenuItem, Select, Typography } from '@mui/material';

import { ReactComponent as DropdownArrow } from 'assets/icons/ChevronDown.svg';

import { ISelectComponentProps } from './types';

import styles from './SelectComponent.module.scss';

const CustomInput = styled(InputBase)({
  '& .MuiInputBase-input': {
    position: 'relative',
  },
});

export const SelectComponent: FC<ISelectComponentProps> = ({
  label,
  onChange,
  value,
  options,
  defaultValue,
  ...props
}) => {
  return (
    <>
      {label && <Typography>{label}</Typography>}
      <Select
        {...props}
        color="primary"
        className={styles.select}
        IconComponent={DropdownArrow}
        value={value}
        onChange={onChange}
        input={<CustomInput />}
        defaultValue={defaultValue}
        inputProps={{
          className: styles.inputStyles,
        }}
        MenuProps={{
          MenuListProps: {
            sx: {
              padding: '4px',
            },
          },
        }}
      >
        {options.map(({ value, label }) => (
          <MenuItem key={value} value={value} className={styles.menuItemStyles}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
